// extracted by mini-css-extract-plugin
export default {"root":"MessageLoader_root__55gQY","loader":"MessageLoader_loader__DGRs0","bblFadInOut":"MessageLoader_bblFadInOut__Rr1Xj"};